export default "__VITE_ASSET__IneAzWun__"